import React, { useEffect, useState } from "react";
import { FormGroup, Label } from "reactstrap";
import { Btn } from "../../../AbstractElements";
import CustomSelect from "../../../Shared/Components/Form/CustomSelect";
import { SUCCESS_API_RESPONSE } from "../../../Shared/Constants/api";
import { getUsersApi } from "../../../Shared/Api/getUsers";

import { MODEL_TYPE_ENUM } from "../../../Shared/Constants/enums";

import { formatUsersList } from "../../../Shared/Utils/Formatters/FormatUsers";

export default function FormAddUserComponent({
  setCurrentUsers,
  currentUsers,
}) {
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);

  useEffect(() => {
    fetchAndFormatUsers();
  }, []);

  const fetchAndFormatUsers = async () => {
    const response = await getUsersApi();
    if (response.result === SUCCESS_API_RESPONSE) {
      const formattedUsers = formatUsersList(response.data?.items);
      setUsers(formattedUsers);
    }
  };

  const handleUserChange = (user) => {
    setSelectedUser(user);
  };

  const addUserToList = () => {
    if (!selectedUser) return;

    const existingUser = findExistingUser(selectedUser.id);

    if (existingUser) {
      updateExistingUser(existingUser);
    } else {
      addNewUser();
    }
  };

  const findExistingUser = (userId) => {
    return currentUsers.find((u) => u.model_id === userId);
  };

  const updateExistingUser = (user) => {
    delete user.deleted;
    setCurrentUsers([...currentUsers]);
  };

  const addNewUser = () => {
    setCurrentUsers([
      ...currentUsers,
      {
        ...{
          model_type: MODEL_TYPE_ENUM.USER,
          model_id: selectedUser.id,
          name: selectedUser.name,
        },
      },
    ]);
  };

  return (
    <FormGroup>
      <Label>Usuarios</Label>
      <div className="d-flex">
        <CustomSelect
          placeholder="Buscar usuario"
          className="form-control"
          items={users}
          item={selectedUser}
          customChangeHandler={handleUserChange}
        />
        <Btn
          attrBtn={{
            color: "outline-primary",
            className: "ms-2",
            onClick: addUserToList,
          }}
        >
          Agregar
        </Btn>
      </div>
    </FormGroup>
  );
}
